import React, { useState, Fragment } from 'react';
import UserRolesLabel from '../../../enums/UserRolesLabel';
import CoordinatorsDetails from './CoordinatorsDetails/index';
import GiversDetails from './GiversDetails/index';
import ReceiversDetails from './ReceiversDetails/index';

export default function DetailsGroup(props) {
    const { match } = props;
    const id = match.params.id;
    const [role] = useState(
        JSON.parse(localStorage.getItem('@Reachout:groupRole'))
    );

    return (
        <Fragment>
            {role === UserRolesLabel.COORDINATOR ||
            role === UserRolesLabel.OWNER ? (
                <CoordinatorsDetails id={id} />
            ) : role === UserRolesLabel.GIVER ? (
                <GiversDetails id={id} />
            ) : (
                <ReceiversDetails id={id} />
            )}
        </Fragment>
    );
}
